import React, { FC } from 'react'
import { Table, Button } from 'antd'
import moment from 'moment'
import { DownloadOutlined } from '@ant-design/icons'
const stateMaps = {
  ACCEPTED: '待处理',
  RUNNING: '处理中',
  FINISHED: '已完成',
}

const formate = 'YYYY-MM-DD HH:mm:ss'

interface TaskListProps {
  dataSource: any[]
}

const TaskList:FC<TaskListProps> = ({ dataSource }) => {
  const columns = [
    {
      title: '任务ID',
      dataIndex: 'id',
      key: 'taskId',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: status => stateMaps[status],
    },
    {
      title: '创建时间',
      dataIndex: 'created',
      key: 'created',
      render: created => (created ? moment(created).format(formate) : created),
    },
    {
      title: '完成时间',
      dataIndex: 'lastUpdated',
      key: 'lastUpdated',
      render: lastUpdated => (lastUpdated ? moment(lastUpdated).format(formate) : lastUpdated),
    },
    {
      title: '下载',
      dataIndex: 'result',
      key: 'result',
      render: result => (
        result? (<Button type="link" href={result}>
          <DownloadOutlined />
        </Button>) : null
      ),
    },
  ]


  return (
     <Table 
        size="small"
        bordered
        dataSource={dataSource}
        columns={columns}
        rowKey="id"
      />
  )
}

export default TaskList